class LocalStorageManager {
  static setItem(key, value) {
      //localStorage.setItem(key, JSON.stringify(value));
      localStorage.setItem(key, value);
  }

  static getItem(key) {
      const item = localStorage.getItem(key);
      //return item ? JSON.parse(item) : null;
      return item??null;
  }

  static removeItem(key) {
      localStorage.removeItem(key);
  }

  static clear() {
      localStorage.clear();
  }
}

export default LocalStorageManager;